import React, { useContext, useEffect, useMemo, useRef, useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Badge from "@material-ui/core/Badge";
import MoveToInboxIcon from "@material-ui/icons/MoveToInbox";
// import CheckBoxIcon from "@material-ui/icons/CheckBox";
import PowerIcon from "@material-ui/icons/Power";

// import FormControlLabel from "@material-ui/core/FormControlLabel";
// import Switch from "@material-ui/core/Switch";

import NewTicketModal from "../NewTicketModal";
import TicketFiltersModal from "../TicketFiltersModal";
import TicketTransferirModal from "../TicketTransferirModal";
import TicketAlterarEtapa from "../TicketAlterarEtapa";
import TicketAlterarEtiqueta from "../TicketAlterarEtiqueta";
import TicketTagsLead from "../TicketTagsLead";
import TicketsList from "../TicketsList";
import TicketsWhatsappList from "../TicketsWhatsappList";
import TabPanel from "../TabPanel";


import { TextField, FormControl, Grid } from "@material-ui/core";
import TicketsQueueSelect from "../TicketsQueueSelect";
import TicketsTagSelect from "../TicketsTagSelect";
import TicketsSemRespostaSelect from "../TicketsSemRespostaSelect";
import TicketsWhatsappSelect from "../TicketsWhatsappSelect";
import TicketsUserSelect from "../TicketsUserSelect";
import TicketsFilialSelect from "../TicketsFilialSelect";
import TicketAgendamentos from "../TicketAgendamentos";
import BlacklistModal from "../BlacklistModal";
import NotificationSettingsModal from "../NotificationSettingsModal";

import { i18n } from "../../translate/i18n";
import { AuthContext } from "../../context/Auth/AuthContext";
import toastError from "../../errors/toastError";
import { urlRetornoErp, temUrlErp } from "../../helpers/urlRetornoCrm";
import { registrarConsumidorEsc } from "../../helpers/escConversa";
import { rotuloContagem } from "../../helpers/listaTickets";
// import { Can } from "../Can";
// import TicketsQueueSelect from "../TicketsQueueSelect";
// import TicketsTagSelect from "../TicketsTagSelect";
// import TicketsSemRespostaSelect from "../TicketsSemRespostaSelect";
// import TicketsWhatsappSelect from "../TicketsWhatsappSelect";
// import { Button } from "@material-ui/core";
import ButtonWithSpinner from "../ButtonWithSpinner";

import { Menu, MenuItem, Button, Fab, Tooltip, IconButton, Divider, ListSubheader } from "@mui/material";
import {
  MoreVert,
  Settings as SettingsIcon,
  Close as CloseIcon,
  SwapHoriz as SwapHorizIcon,
  DoneAll as DoneAllIcon,
  Block as BlockIcon,
  Flag as FlagIcon,
  LocalOffer as LocalOfferIcon,
  MarkChatUnread as MarkChatUnreadIcon,
} from "@mui/icons-material";
import api from "../../services/api";




import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Title from "../Title";



const useStyles = makeStyles((theme) => ({
  ticketsWrapper: {
    position: "relative",
    display: "flex",
    height: "100%",
    flexDirection: "column",
    overflow: "hidden",
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },

  tabsHeader: {
    flex: "none",
    backgroundColor: theme.palette.background.default,
  },

  settingsIcon: {
    alignSelf: "center",
    marginLeft: "auto",
    padding: 8,
  },

  // minWidth 0 em vez de 120: com variant="fullWidth" as abas dividem o espaço
  // igualmente, mas o piso de largura fazia a soma estourar o container (que é
  // overflow hidden) em zoom/monitor pequeno e escondia as abas da direita.
  tab: {
    minWidth: 0,
    width: 120,
  },

  // Abas internas (Contatos/Grupos/Aguardando): o MUI impõe minWidth 160 acima
  // do breakpoint sm, então 3 abas exigiam 480px e a última era cortada.
  abaInterna: {
    minWidth: 0,
    paddingLeft: 8,
    paddingRight: 8,
    "& .MuiTab-wrapper": {
      display: "block",
      width: "100%",
    },
  },

  // Trunca com "..." quando a fatia da aba fica estreita, em vez de a palavra
  // ser cortada no meio pelo overflow do container.
  abaInternaLabel: {
    display: "block",
    minWidth: 0,
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  ticketOptionsBox: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column", // Exibe em coluna por padrão
    gap: 8, // Espaço entre os elementos
    "@media (min-width: 600px)": { // Exibe em linha a partir de uma tela média
      flexDirection: "row",
      alignItems: "center",
    },
  },

  ticketOptionsButton: {
    width: "100%", // O Paper ocupa toda a largura da tela
    // Sem maxWidth: 400 — era ele que apertava os botões e fazia o texto quebrar
    // dentro do botão em vez de a fileira quebrar de linha.
    padding: 3, // Espaçamento interno para melhor aparência
    marginLeft: 0, // Alinha à esquerda
    display: "flex", // Exibe os botões em linha
    flexWrap: "wrap", // Em zoom/tela estreita, o que não couber vai pra baixo
    alignItems: "center",
    gap: 8, // Espaçamento uniforme entre os botões
  },

  // Barra contextual da múltipla seleção (aparece só com ticket marcado).
  barraSelecao: {
    flex: "none",
    display: "flex",
    alignItems: "center",
    gap: 2,
    padding: "1px 4px",
    backgroundColor: theme.palette.action.selected,
    borderBottom: `1px solid ${theme.palette.divider}`,
  },

  barraSelecaoTexto: {
    // Mesma escala de fonte das abas e dos botões (segue a configuração).
    fontSize: theme.typography.button.fontSize,
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginLeft: 2,
    marginRight: "auto", // empurra as ações pra direita
  },

  serachInputWrapper: {
    flex: 1,
    backgroundColor: theme.palette.background.default,
    display: "flex",
    borderRadius: 40,
    padding: 4,
    marginRight: theme.spacing(1),
  },

  searchIcon: {
    color: "grey",
    marginLeft: 6,
    marginRight: 6,
    alignSelf: "center",
  },

  searchInput: {
    flex: 1,
    border: "none",
    borderRadius: 30,
  },

  badge: {
    right: "-10px",
    maxWidth: "100%",
  },
  show: {
    display: "block",
  },
  hide: {
    display: "none !important",
  },

  botaoVoltarCRM: {
    position: "fixed",
    width: "50px",
    height: "50px",
    bottom: "50px",
    left: "40px",
    backgroundColor: "#4CAF50",
    color: "#FFF",
    borderRadius: "50px",
    textAlign: "center",
    fontSize: "20px",
    boxShadow: "1px 1px 2px #888",
    zIndex: 1000,
  },
  titleButton:{
    // Antes era '9px' fixo, que ignorava a configuração de tamanho de fonte.
    // Agora usa a MESMA escala das abas (theme.typography.button do tema v4, que
    // o App.js escala pelo fontSize do ColorModeContext). O !important continua
    // necessário porque o Button é do @mui/material (v5/emotion) e a classe do
    // JSS v4 perde a disputa de CSS sem ele.
    fontSize: `${theme.typography.button.fontSize} !important`,
    color: 'white',
    // "Novo lead" quebrava em duas linhas (o container tinha maxWidth 400 e os
    // botões encolhiam), e como o flex estica todos pela altura do maior, a
    // fileira toda ficava alta. Com nowrap + flexShrink 0 cada botão mantém a
    // largura do texto e quem não couber vai pra linha de baixo (flexWrap no
    // ticketOptionsButton).
    whiteSpace: 'nowrap',
    flexShrink: 0,
  },
}));

const TicketsManager = () => {
  const classes = useStyles();

  const [searchParam, setSearchParam] = useState("");
  const [tab, setTab] = useState("open");
  const [tabOpen, setTabOpen] = useState("open");
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  // Só pra alternar o title do cabeçalho dos filtros — o Accordion segue
  // controlando a abertura por conta própria (não virou controlado).
  const [filtrosExpandidos, setFiltrosExpandidos] = useState(false);
  const [ticketTransferirModalOpen, setTicketTransferirModalOpen] = useState(false);
  const [ticketAlterarEtapaModalOpen, setTicketAlterarEtapaModalOpen] = useState(false);
  const [ticketAlterarEtiquetaModalOpen, setTicketAlterarEtiquetaModalOpen] = useState(false);
  const [ticketTagsLeadModalOpen, setTicketTagsLeadModalOpen] = useState(false);
  const [ticketAgendamentoOpen, setTicketAgendamentoOpen] = useState(false);
  const [blacklistModalOpen, setBlacklistModalOpen] = useState(false);
  const [notificationSettingsModalOpen, setNotificationSettingsModalOpen] = useState(false);
  const [showAllTickets, setShowAllTickets] = useState(false);
  const searchInputRef = useRef();
  const { user, aplicarStatusOnline } = useContext(AuthContext);

  const [openCount, setOpenCount] = useState(0);
  const [groupCount, setGroupCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);

  const userQueueIds = (user?.queues || []).map((q) => q.id);
  // Gestor também entra com TODAS as conexões marcadas, igual ao usuário comum.
  // Antes começava com nenhuma e a tela vinha vazia até ele marcar na mão — o
  // ListTicketsService monta `whatsappId IN (...)` com a seleção, e lista vazia
  // vira `IN (NULL)` (nenhuma conversa). As opções do filtro são as mesmas nos
  // dois casos (user.whatsapps), então marcar tudo não amplia o escopo dele.
  const userWhatsappIds = (user?.whatsapps || []).map((w) => w.id);
  const podeAcessarTodasConexoes = !!user?.gestor;
  const [selectedQueueIds, setSelectedQueueIds] = useState(userQueueIds || []);
  const [selectedTagId, setSelectedTagId] = useState("");
  const [selectedWhatsappIds, setSelectedWhatsappIds] = useState(userWhatsappIds || []);
  const [allAtendentes, setAllAtendentes] = useState([]);
  const [allFiliais, setAllFiliais] = useState([]);
  const [selectedUserIds, setSelectedUserIds] = useState(null);
  const [selectedFilialIds, setSelectedFilialIds] = useState(null);
  const [selectedTime, setSelectedTime] = useState("Todos");
  // Aba Grupos: o "Filtrar por resposta" vira "Filtrar por leitura" (grupo não
  // tem SLA de resposta). Estado próprio pra não levar um valor de SLA pra aba de
  // grupo (e vice-versa) ao trocar de aba; viaja no mesmo parâmetro selectedTime.
  const [selectedLeitura, setSelectedLeitura] = useState("Todos");
  const [dataInicio, setDataInicio] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedTickets, setSelectedTickets] = useState([]);
  // Menu de contexto (botão direito num ticket da lista): { top, left }.
  const [menuContexto, setMenuContexto] = useState(null);
  // Alvo da próxima ação de lead. `null` = a múltipla seleção (barra). Preenchido
  // pelo menu de contexto com { ids, daSelecao, nome }.
  const [alvoAcao, setAlvoAcao] = useState(null);
  const [loading, setLoading] = useState(false);

  // Filial enviada para o backend: só filtra quando há uma seleção parcial.
  // Nenhuma OU todas as filiais selecionadas => null (não filtra, traz todas as
  // conversas — inclusive as de atendente sem filial informada, que um IN com
  // todas as filiais deixaria de fora).
  const filialIdsFiltro = useMemo(() => {
    if (!Array.isArray(selectedFilialIds) || selectedFilialIds.length === 0) return null;
    const totalFiliais = Array.isArray(allFiliais) ? allFiliais.length : 0;
    if (totalFiliais > 0 && selectedFilialIds.length >= totalFiliais) return null;
    return selectedFilialIds;
  }, [selectedFilialIds, allFiliais]);

  // Conexão que já vem escolhida no "Novo lead": a primeira conexão FILTRADA na
  // tela. Usa a ordem da lista de conexões (alfabética, como vem do backend) e não
  // a ordem em que o usuário clicou no filtro, pra ser previsível. Sem filtro real
  // (nenhuma ou todas marcadas) cai na primeira da lista, como era antes.
  // Escalar (id), então calcular no render não gera re-render extra no modal.
  const conexoesDisponiveis = user?.whatsapps || [];
  const conexaoNovoLead =
    conexoesDisponiveis.find((w) => selectedWhatsappIds.includes(w.id))
    || conexoesDisponiveis[0];
  const whatsappIdNovoLead = conexaoNovoLead ? conexaoNovoLead.id : "";

  // Mesma regra pro atendente. Antes esta lista ia só pro filtro client-side do
  // TicketsList, que filtrava a página já carregada: com muitos tickets, o
  // atendente escolhido podia não estar em nenhuma página baixada e a lista vinha
  // vazia. Agora vai pro backend (WHERE userId IN (...)) e a paginação é da
  // consulta filtrada.
  const userIdsFiltro = useMemo(() => {
    if (!Array.isArray(selectedUserIds) || selectedUserIds.length === 0) return null;
    const totalAtendentes = Array.isArray(allAtendentes) ? allAtendentes.length : 0;
    if (totalAtendentes > 0 && selectedUserIds.length >= totalAtendentes) return null;
    return selectedUserIds;
  }, [selectedUserIds, allAtendentes]);

  useEffect(() => {
    if (user?.profile && user.profile.toUpperCase() === "ADMIN") {
      setShowAllTickets(true);
    }
    //  eslint-disable-next-line, react-hooks/exhaustive-deps
  }, [user?.profile]);

  // Recupera as seleções iniciais quando o user é populado. Se este componente
  // montar num render transitório com user={} (corrida pós-login), as useState
  // iniciais ficariam vazias e nenhuma conversa carregaria sem F5. Roda uma vez.
  const didInitSelections = useRef(false);
  useEffect(() => {
    if (didInitSelections.current) return;
    if (!user?.id) return;
    setSelectedQueueIds((user.queues || []).map((q) => q.id));
    setSelectedWhatsappIds((user.whatsapps || []).map((w) => w.id));
    didInitSelections.current = true;
    //  eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  useEffect(() => {
    if (!podeAcessarTodasConexoes) return;
    let active = true;
    // Não cacheia entre empresas: refaz a chamada quando o filialIcode da empresa
    // logada muda. O backend (/filiais-distinct) sempre envia o filialIcode ao ERP.
    (async () => {
      try {
        const [atendentesRes, filiaisRes] = await Promise.all([
          api.get("/users-atendentes"),
          api.get("/filiais-distinct"),
        ]);
        if (!active) return;
        const atendentes = Array.isArray(atendentesRes.data) ? atendentesRes.data : [];
        // Fail-closed: payload inesperado vira [] => filtro de filial oculto.
        const filiais = Array.isArray(filiaisRes.data) ? filiaisRes.data : [];
        setAllAtendentes(atendentes);
        setAllFiliais(filiais);
        setSelectedUserIds(atendentes.map((u) => u.id));
        setSelectedFilialIds(filiais.map((f) => f.id));
      } catch (err) {
        // Erro de rede / status != 200: zera a lista => filtro some (fail-closed).
        if (active) setAllFiliais([]);
        toastError(err);
      }
    })();
    return () => {
      active = false;
    };
  }, [podeAcessarTodasConexoes, user?.filial_icode]);

  useEffect(() => {
    if (tab === "search") {
      searchInputRef.current.focus();
    }
  }, [tab]);

  useEffect(() => {
    setSelectedTickets([]);
  }, [tab, tabOpen, searchParam, selectedQueueIds, selectedWhatsappIds, selectedUserIds, selectedFilialIds, selectedTime, selectedLeitura, selectedTagId, dataInicio, dataFim, showAllTickets]);

  // ESC em camadas: antes de fechar a conversa (ver hooks/useEscFecharConversa),
  // desfaz o que está "ligado" na listagem — primeiro a múltipla seleção, depois
  // a busca ativa. Ver helpers/escConversa.js.
  useEffect(() => registrarConsumidorEsc(() => {
    if (selectedTickets.length > 0) {
      setSelectedTickets([]);
      return true;
    }
    if (searchParam) {
      if (searchInputRef.current) searchInputRef.current.value = "";
      setSearchParam("");
      return true;
    }
    return false;
  }), [selectedTickets.length, searchParam]);

  // let searchTimeout;

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      const searchedTerm = e.target.value.toLowerCase();

      // clearTimeout(searchTimeout);

      if (searchedTerm === "") {
        setSearchParam(searchedTerm);
        // setTab("open");
        return;
      }

      setSearchParam(searchedTerm);

      // searchTimeout = setTimeout(() => {
      //   setSearchParam(searchedTerm);
      // }, 500);
    }
  };

  const handleChangeTab = (e, newValue) => {
    setTab(newValue);
  };

  const handleChangeTabOpen = (e, newValue) => {
    setTabOpen(newValue);
  };

  const applyPanelStyle = (status) => {
    if (tabOpen !== status) {
      return { width: 0, height: 0 };
    }
  };

  // Aba Grupos: grupo não tem lead, então nem os filtros de lead (etapa,
  // atendente, filial) nem as ações de lead (transferir, etapa, etiqueta,
  // blacklist) valem ali — só marcar como lido / não lido.
  const abaGrupos = tabOpen === "grupos";

  // Alvo das ações de lead. Sem menu de contexto aberto o alvo é a múltipla
  // seleção (comportamento original da barra). O menu de contexto define um alvo
  // próprio em `alvoAcao` — ver handleAbrirMenuContexto.
  const idsAlvo = alvoAcao ? alvoAcao.ids : selectedTickets;
  // Só limpa os checkboxes quando a ação foi sobre a seleção; ação disparada pelo
  // botão direito num ticket de fora dela não pode desmarcar nada.
  const alvoEhSelecao = !alvoAcao || alvoAcao.daSelecao;

  // Nos handlers de ação em lote a seleção só é limpa quando a ação REALMENTE
  // aconteceu. Cancelar a modal (ou erro na API) mantém os tickets marcados,
  // senão era preciso remarcar tudo de novo. O alvo do menu de contexto, ao
  // contrário, é sempre descartado no fim (vale por uma ação só).
  const handleTransferirLead = async (value) => {
    setTicketTransferirModalOpen(false);
    const ids = idsAlvo;
    const eraSelecao = alvoEhSelecao;
    setAlvoAcao(null);
    if (!value || !ids?.length) return; // cancelou
    try {
      await api.post(`/transferirlead`, {
        userLogadoId: user?.id,
        userDestinoId: value,
        leads: ids
      });
      if (eraSelecao) setSelectedTickets([]);
    } catch (err) {
      toastError(err);
    }
  };

  const handleAlterarEtapa = async (value) => {
    setTicketAlterarEtapaModalOpen(false);
    const ids = idsAlvo;
    const eraSelecao = alvoEhSelecao;
    setAlvoAcao(null);
    if (!value || !ids?.length) return; // cancelou
    try {
      await api.post(`/transferiretapaticket`, {
        etapaId: value,
        userId: user?.id,
        leads: ids
      });
      if (eraSelecao) setSelectedTickets([]);
    } catch (err) {
      toastError(err);
    }
  };

  const handleMarcarLidoLead = async () => {
    const ids = idsAlvo;
    const eraSelecao = alvoEhSelecao;
    setAlvoAcao(null);
    if (!ids?.length) return;
    try {
      await api.post(`/marcarrespondido`, {
        ticketsId: ids,
        userName: user?.name
      });
      if (eraSelecao) setSelectedTickets([]);
    } catch (err) {
      toastError(err); // mantém marcado pra poder tentar de novo
    }
  };

  const handleAddSelectedToBlacklist = async () => {
    const ids = idsAlvo;
    const eraSelecao = alvoEhSelecao;
    const nomeAlvo = alvoAcao?.nome;
    setAlvoAcao(null);
    if (!ids?.length) return;
    const quem = ids.length === 1
      ? `a conversa${nomeAlvo ? ` de ${nomeAlvo}` : ""}`
      : `${ids.length} conversas`;
    const confirmar = window.confirm(
      `Adicionar ${quem} à blacklist?\n\nAs conversas serão ocultadas e novas mensagens desses contatos serão ignoradas.`
    );
    if (!confirmar) return; // cancelou: mantém a seleção
    try {
      await api.post(`/blacklist/bulk`, {
        ticketIds: ids,
        createdBy: user?.id
      });
      if (eraSelecao) setSelectedTickets([]);
    } catch (err) {
      toastError(err); // mantém marcado pra poder tentar de novo
    }
  };

  const handleAlterarEtiqueta = async (value) => {
    setTicketAlterarEtiquetaModalOpen(false);
    const ids = idsAlvo;
    const eraSelecao = alvoEhSelecao;
    setAlvoAcao(null);
    // Aqui o "cancelou" é undefined mesmo (null/0 é etiqueta válida — limpar).
    if (value === undefined || !ids?.length) return;
    try {
      await api.post(`/alterartaglead`, {
        tagId: value,
        ticketsId: ids
      });
      if (eraSelecao) setSelectedTickets([]);
    } catch (err) {
      toastError(err);
    }
  };

  const handleMarcarNaoLidoLead = async () => {
    const ids = idsAlvo;
    const eraSelecao = alvoEhSelecao;
    setAlvoAcao(null);
    if (!ids?.length) return;
    try {
      await api.post(`/marcarnaorespondido`, {
        ticketsId: ids,
        userName: user?.name
      });
      if (eraSelecao) setSelectedTickets([]);
    } catch (err) {
      toastError(err); // mantém marcado pra poder tentar de novo
    }
  };

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = (menu) => {
    if (menu === "transferLead") {
      setTicketTransferirModalOpen(true);
    } else if (menu === "alterarLead") {
      setTicketAlterarEtapaModalOpen(true);
    } else if (menu === "alterarEtiqueta") {
      setTicketAlterarEtiquetaModalOpen(true);
    } else if (menu === "tagsLead") {
      setTicketTagsLeadModalOpen(true);
    } else if (menu === "marcarLido") {
      handleMarcarLidoLead();
    } else if (menu === "blacklist") {
      handleAddSelectedToBlacklist();
    } else if (menu === "marcarNaoLido") {
      handleMarcarNaoLidoLead();
    }
    setAnchorEl(null);
  };

  // Botão direito num ticket da lista: abre as mesmas ações da barra de múltipla
  // seleção, mas mirando o ticket clicado. Se ele já faz parte da seleção, a ação
  // vale pra seleção inteira (igual gerenciador de arquivos) — assim não tem como
  // achar que agiu nos 5 marcados e ter agido em 1 só.
  const handleAbrirMenuContexto = (event, ticket) => {
    event.preventDefault();
    const daSelecao = selectedTickets.includes(ticket.id);
    setAlvoAcao({
      ids: daSelecao ? selectedTickets : [ticket.id],
      daSelecao,
      nome: ticket.contact?.name,
      // Grupo: o menu fica só com marcar como lido / não lido.
      ehGrupo: !!ticket.isGroup,
    });
    setMenuContexto({ top: event.clientY, left: event.clientX });
  };

  // Fechar sem escolher nada (ESC, clique fora) descarta o alvo. Escolher uma ação
  // usa executarAcaoContexto, que fecha o menu mas preserva o alvo até o fim dela.
  const handleFecharMenuContexto = () => {
    setMenuContexto(null);
    setAlvoAcao(null);
  };

  const executarAcaoContexto = (acao) => {
    setMenuContexto(null);
    handleCloseMenu(acao);
  };

  // Quem inverte é o ERP, sobre o estado real dele: mandar daqui o estado que a tela achava
  // que era fazia o clique não fazer nada sempre que os dois divergiam. O botão repinta pelo
  // que voltou na resposta, sem depender de o socket de volta chegar.
  const handleOnlieOffline = async () => {
    if (!user) return;

    setLoading(true);
    try {
      const { data } = await api.post(`/useronlineoffline`, {
        userId: user.id,
        userOnline: user.onLine,
      });
      if (typeof data?.onLine === "boolean") {
        aplicarStatusOnline(data.onLine);
      }
    } catch (err) {
      toastError(err);
    }
    setLoading(false);
  };

  return (
    <Paper elevation={0} variant="outlined" className={classes.ticketsWrapper}>
      {/* Config saiu da fileira de botões e virou flutuante no canto superior
        esquerdo — mesma ideia do botão verde de voltar pro CRM, que fica no
        canto inferior esquerdo. */}
      <Tooltip title={i18n.t("settingsSidebar.title")} placement="right" arrow>
        <Fab
          size="small"
          color="primary"
          aria-label={i18n.t("settingsSidebar.title")}
          onClick={() => setNotificationSettingsModalOpen(true)}
          /* sx (emotion) em vez de makeStyles: o Fab é do @mui/material (v5) e
             classe do JSS v4 perde a disputa de CSS com o estilo próprio dele
             (é por isso que o titleButton daqui precisa de !important). Fica no
             canto vazio da aba "Conexões", cujo rótulo é centralizado. */
          sx={{
            position: "fixed",
            top: 8,
            left: 8,
            width: 34,
            height: 34,
            minHeight: 34,
            zIndex: 1200,
            boxShadow: "1px 1px 4px rgba(0, 0, 0, 0.35)",
          }}
        >
          <SettingsIcon fontSize="small" />
        </Fab>
      </Tooltip>
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        whatsApps={user?.whatsapps || []}
        whatsappIdPadrao={whatsappIdNovoLead}
        onClose={(e) => setNewTicketModalOpen(false)}
      />
      <TicketTransferirModal
        modalOpen={ticketTransferirModalOpen}
        user={user}
        onClose={(value) => handleTransferirLead(value)}
      />
      <TicketAlterarEtapa
        modalOpen={ticketAlterarEtapaModalOpen}
        user={user}
        onClose={(value) => handleAlterarEtapa(value)}
      />
      <TicketAlterarEtiqueta
        modalOpen={ticketAlterarEtiquetaModalOpen}
        user={user}
        onClose={(value) => handleAlterarEtiqueta(value)}
      />
      <TicketTagsLead
        modalOpen={ticketTagsLeadModalOpen}
        ticketId={idsAlvo?.[0]}
        onClose={() => {
          setTicketTagsLeadModalOpen(false);
          setAlvoAcao(null);
        }}
      />
      <TicketAgendamentos
        modalOpen={ticketAgendamentoOpen}
        user={user}
        status="open"
        searchParam={searchParam}
        showAll={showAllTickets}
        selectedQueueIds={selectedQueueIds}
        selectedWhatsappIds={selectedWhatsappIds}
        selectedUserIds={userIdsFiltro}
        selectedFilialIds={filialIdsFiltro}
        selectedTime={selectedTime}
        selectedTag={selectedTagId}
        dataInicio={dataInicio}
        dataFim={dataFim}
        onClose={() => setTicketAgendamentoOpen(false)}
      />
      <BlacklistModal
        open={blacklistModalOpen}
        onClose={() => setBlacklistModalOpen(false)}
      />
      <NotificationSettingsModal
        open={notificationSettingsModalOpen}
        onClose={() => setNotificationSettingsModalOpen(false)}
      />
      <Paper elevation={0} square className={classes.tabsHeader}>
        <Tabs
          value={tab}
          onChange={handleChangeTab}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          aria-label="icon label tabs example"
        >
          <Tab
            value={"conexoes"}
            icon={<PowerIcon />}
            label={"Conexões"}
            classes={{ root: classes.tab }}
          />
          <Tab
            value={"open"}
            icon={<MoveToInboxIcon />}
            label={i18n.t("tickets.tabs.open.title")}
            classes={{ root: classes.tab }}
          />
        </Tabs>
      </Paper>

      <Paper square elevation={0} className={classes.ticketOptionsBox}>
        <div className={classes.serachInputWrapper}>
          <SearchIcon className={classes.searchIcon} />
          <InputBase
            name="ticketSearch"
            className={classes.searchInput}
            inputRef={searchInputRef}
            placeholder={i18n.t("tickets.search.placeholder")}
            type="search"
            onKeyDown={handleSearch}
          />
        </div>
      </Paper>
      <div>
        <Accordion onChange={(e, expandido) => setFiltrosExpandidos(expandido)}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            // Os botões abaixo têm title próprio pra não herdarem este aqui.
            title={filtrosExpandidos ? "Esconder filtros" : "Expandir filtros"}
          >
            <Typography>
              <Paper square elevation={0} className={classes.ticketOptionsButton}>
                {user.renderBotaoNovo && (
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    className={classes.titleButton}
                    title="Novo lead"
                    onClick={(e) => {
                      e.stopPropagation();  // Previne a expansão ao clicar no botão
                      setNewTicketModalOpen(true);
                    }}
                  >
                    Novo lead
                  </Button>
                )}

                {process.env.REACT_APP_REMOVER_AGENDAMENTO != 'on' && (
                  <Button
                    size="small"
                    variant="contained"
                    color="primary"
                    className={classes.titleButton}
                    title="Agendamentos"
                    onClick={(e) => {
                      e.stopPropagation();
                      setTicketAgendamentoOpen(true);
                    }}
                  >
                    Agendamentos
                  </Button>
                )}

                {/* Verde/vermelho sólido, como sempre foi. O title é que explica
                  o que acontece ao clicar — antes era só "Online"/"Offline",
                  que repetia o rótulo e não indicava que o botão alterna. */}
                <Button
                  size="small"
                  variant="contained"
                  color={user.onLine ? "success" : "error"}
                  disabled={loading}
                  className={classes.titleButton}
                  title={user.onLine
                    ? "Você está online — clique para ficar offline"
                    : "Você está offline — clique para ficar online"}
                  onClick={(e) => {
                    e.stopPropagation();  // Previne a expansão
                    handleOnlieOffline();
                  }}
                >
                  {user.onLine ? "Online" : "Offline"}
                </Button>

                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  className={classes.titleButton}
                  title="Blacklist"
                  onClick={(e) => {
                    e.stopPropagation();
                    setBlacklistModalOpen(true);
                  }}
                >
                  Blacklist
                </Button>

                {/* As ações da múltipla seleção saíram daqui: agora ficam na
                  barra contextual que aparece acima da lista, junto do contador
                  e do botão de limpar seleção. */}
              </Paper>
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography>
              <div style={{ margin: "4px" }}>
                <Grid container spacing={1}>
                  <Grid item xs={10} sm={6}>
                    <TextField
                      label="Data inicial"
                      variant="outlined"
                      type="date"
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      value={dataInicio}
                      onChange={(e) => setDataInicio(e.target.value)}
                      sx={{
                        fontSize: '0.85rem',
                        '& input': {
                          fontSize: '0.85rem',
                          padding: '8px',
                        },
                        '& label': {
                          fontSize: '0.85rem',
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={10} sm={6}>
                    <TextField
                      label="Data final"
                      variant="outlined"
                      type="date"
                      fullWidth
                      size="small"
                      InputLabelProps={{ shrink: true }}
                      value={dataFim}
                      onChange={(e) => setDataFim(e.target.value)}
                      sx={{
                        fontSize: '0.85rem',
                        '& input': {
                          fontSize: '0.85rem',
                          padding: '8px',
                        },
                        '& label': {
                          fontSize: '0.85rem',
                        },
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <TicketsWhatsappSelect
                      selectedWhatsAppIds={selectedWhatsappIds}
                      whatsApps={user?.whatsapps || []}
                      onChange={(values) => setSelectedWhatsappIds(values)}
                    />
                  </Grid>

                  {/* Na aba Grupos este filtro passa a ser por LEITURA (lido / não
                      lido): grupo é conversa coletiva, não tem SLA de resposta de
                      atendente. Estado próprio (selectedLeitura). */}
                  <Grid item xs={12} sm={6}>
                    <TicketsSemRespostaSelect
                      modoLeitura={abaGrupos}
                      selectedTime={abaGrupos ? selectedLeitura : selectedTime}
                      onChange={(value) => abaGrupos ? setSelectedLeitura(value) : setSelectedTime(value)}
                    />
                  </Grid>

                  {/* Etapa, atendente e filial são campos de LEAD, e grupo não tem
                      lead: na aba Grupos os três filtros nem aparecem, em vez de
                      ficarem visíveis sem efeito. Ver ListTicketsService, ramo 'grupos'. */}
                  {!abaGrupos && (
                    <Grid item xs={12} sm={6}>
                      <TicketsQueueSelect
                        selectedQueueIds={selectedQueueIds}
                        userQueues={user?.queues}
                        onChange={(values) => setSelectedQueueIds(values)}
                      />
                    </Grid>
                  )}

                  <Grid item xs={12} sm={6}>
                    <TicketsTagSelect
                      tag={selectedTagId}
                      onChange={(values) => setSelectedTagId(values)}
                    />
                  </Grid>

                  {podeAcessarTodasConexoes && !abaGrupos && (
                    <>
                      <Grid item xs={12} sm={6}>
                        <TicketsUserSelect
                          users={allAtendentes}
                          selectedUserIds={selectedUserIds}
                          onChange={(values) => setSelectedUserIds(values)}
                        />
                      </Grid>

                      {/* Filtro de filial: só aparece quando o ERP retorna 1+ filiais
                          (empresa MATRIZ). Filial/empresa comum/sem filialIcode => [] => oculto.
                          Fail-closed: qualquer erro/payload inesperado mantém allFiliais = [] => oculto. */}
                      {Array.isArray(allFiliais) && allFiliais.length > 0 && (
                        <Grid item xs={12} sm={6}>
                          <TicketsFilialSelect
                            filiais={allFiliais}
                            selectedFilialIds={selectedFilialIds}
                            onChange={(values) => setSelectedFilialIds(values)}
                          />
                        </Grid>
                      )}
                    </>
                  )}
                </Grid>
              </div>
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
      <TabPanel value={tab} name="open" className={classes.ticketsWrapper}>
        {/*  <TabPanel value="open" name="open" className={classes.ticketsWrapper}>*/}
        <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/font-awesome/4.5.0/css/font-awesome.min.css"></link>
        {temUrlErp() && (
          <a href={urlRetornoErp()}
            className={classes.botaoVoltarCRM} target="_self" title="Retornar ao ERP">
            <i style={{ marginTop: "16px" }} className="fa fa-mail-reply"></i>
          </a>
        )}
        <Tabs
          value={tabOpen}
          onChange={handleChangeTabOpen}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
        >
          <Tab
            className={classes.abaInterna}
            label={
              <Badge
                overlap="rectangular"
                className={classes.badge}
                max={99999}
                badgeContent={openCount}
                color="primary"
              >
                <span className={classes.abaInternaLabel}>Contatos</span>
              </Badge>
            }
            value={"open"}
          />
          <Tab
            className={classes.abaInterna}
            label={
              <Badge
                overlap="rectangular"
                className={classes.badge}
                max={99999}
                badgeContent={groupCount}
                color="primary"
              >
                <span className={classes.abaInternaLabel}>Grupos</span>
              </Badge>
            }
            value={"grupos"}
          />
          {user.renderAbaAguardando ? (
            <Tab
              className={classes.abaInterna}
              label={
                <Badge
                  className={classes.badge}
                  max={99999}
                  badgeContent={pendingCount}
                  color="secondary"
                >
                  <span className={classes.abaInternaLabel}>
                    {i18n.t("ticketsList.pendingHeader")}
                  </span>
                </Badge>
              }
              value={"pending"}
            />
          ) : (<></>)}
        </Tabs>

        {/* Barra contextual da múltipla seleção: só existe quando há ticket
          marcado, nas abas Contatos e Grupos (as que têm checkbox). Fica encostada
          na lista, que é onde a seleção acontece. Na aba Grupos as ações de lead
          (transferir, etapa, etiqueta, blacklist) não existem — só leitura. */}
        {(tabOpen === "open" || abaGrupos) && selectedTickets.length > 0 && (
          <div className={classes.barraSelecao}>
            <Tooltip title="Limpar seleção" arrow>
              <IconButton size="small" onClick={() => setSelectedTickets([])}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            <span className={classes.barraSelecaoTexto}>
              {selectedTickets.length} selecionado{selectedTickets.length > 1 ? "s" : ""}
            </span>

            {!abaGrupos && (
              <Tooltip title="Transferir lead" arrow>
                <IconButton size="small" onClick={() => setTicketTransferirModalOpen(true)}>
                  <SwapHorizIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            )}

            <Tooltip title={abaGrupos ? "Marcar como lido" : "Marcar como respondido"} arrow>
              <IconButton size="small" onClick={handleMarcarLidoLead}>
                <DoneAllIcon fontSize="small" />
              </IconButton>
            </Tooltip>

            {/* Grupo: só as duas ações de leitura, então "não lido" vira botão
              direto em vez de item escondido no "Mais ações". */}
            {abaGrupos ? (
              <Tooltip title="Marcar como não lido" arrow>
                <IconButton size="small" onClick={handleMarcarNaoLidoLead}>
                  <MarkChatUnreadIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Mais ações" arrow>
                <IconButton size="small" onClick={handleOpenMenu}>
                  <MoreVert fontSize="small" />
                </IconButton>
              </Tooltip>
            )}

            {/* sx normaliza tamanho e espaçamento dos ícones dos itens. */}
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
              sx={{ "& .MuiSvgIcon-root": { fontSize: 18, marginRight: 1 } }}
            >
              <MenuItem onClick={() => handleCloseMenu("alterarLead")}>
                <FlagIcon />
                Alterar etapa do lead
              </MenuItem>
              <MenuItem onClick={() => handleCloseMenu("alterarEtiqueta")}>
                <LocalOfferIcon />
                Alterar etiqueta do lead
              </MenuItem>
              <MenuItem onClick={() => handleCloseMenu("tagsLead")}>
                <LocalOfferIcon />
                Tags do lead
              </MenuItem>
              <MenuItem onClick={() => handleCloseMenu("marcarNaoLido")}>
                <MarkChatUnreadIcon />
                Marcar como não respondido
              </MenuItem>
              {/* Ação destrutiva no padrão do MUI (texto/ícone em error), em vez
                do backgroundColor: 'red' cravado. A confirmação em lote continua
                em handleAddSelectedToBlacklist. */}
              <MenuItem
                onClick={() => handleCloseMenu("blacklist")}
                sx={{ color: "error.main" }}
              >
                <BlockIcon />
                Adicionar à blacklist
              </MenuItem>
            </Menu>
          </div>
        )}

        {/* Menu de contexto do botão direito na lista: as mesmas ações da barra
          de múltipla seleção. Ancorado na posição do cursor (anchorPosition), não
          num elemento. O cabeçalho diz em quem a ação vai bater. */}
        <Menu
          open={!!menuContexto}
          onClose={handleFecharMenuContexto}
          anchorReference="anchorPosition"
          anchorPosition={menuContexto || undefined}
          sx={{ "& .MuiSvgIcon-root": { fontSize: 18, marginRight: 1 } }}
        >
          <ListSubheader
            sx={{
              lineHeight: "24px",
              paddingTop: "4px",
              fontWeight: 600,
              maxWidth: 260,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {alvoAcao?.daSelecao
              ? `${alvoAcao.ids.length} selecionada${alvoAcao.ids.length > 1 ? "s" : ""}`
              : alvoAcao?.nome || "Conversa"}
          </ListSubheader>
          {/* Grupo não tem lead: sobram só as duas ações de leitura. */}
          {alvoAcao?.ehGrupo ? (
            <>
              <MenuItem onClick={() => executarAcaoContexto("marcarLido")}>
                <DoneAllIcon />
                Marcar como lido
              </MenuItem>
              <MenuItem onClick={() => executarAcaoContexto("marcarNaoLido")}>
                <MarkChatUnreadIcon />
                Marcar como não lido
              </MenuItem>
            </>
          ) : (
            <>
              <MenuItem onClick={() => executarAcaoContexto("transferLead")}>
                <SwapHorizIcon />
                Transferir lead
              </MenuItem>
              <MenuItem onClick={() => executarAcaoContexto("marcarLido")}>
                <DoneAllIcon />
                Marcar como respondido
              </MenuItem>
              <MenuItem onClick={() => executarAcaoContexto("alterarLead")}>
                <FlagIcon />
                Alterar etapa do lead
              </MenuItem>
              <MenuItem onClick={() => executarAcaoContexto("alterarEtiqueta")}>
                <LocalOfferIcon />
                Alterar etiqueta do lead
              </MenuItem>
              <MenuItem onClick={() => executarAcaoContexto("tagsLead")}>
                <LocalOfferIcon />
                Tags do lead
              </MenuItem>
              <MenuItem onClick={() => executarAcaoContexto("marcarNaoLido")}>
                <MarkChatUnreadIcon />
                Marcar como não respondido
              </MenuItem>
              <Divider />
              <MenuItem
                onClick={() => executarAcaoContexto("blacklist")}
                sx={{ color: "error.main" }}
              >
                <BlockIcon />
                Adicionar à blacklist
              </MenuItem>
            </>
          )}
        </Menu>

        <Paper className={classes.ticketsWrapper}>
          <TicketsList
            status="open"
            searchParam={searchParam}
            showAll={showAllTickets}
            selectedQueueIds={selectedQueueIds}
            selectedWhatsappIds={selectedWhatsappIds}
            selectedUserIds={userIdsFiltro}
            selectedFilialIds={filialIdsFiltro}
            selectedTime={selectedTime}
            selectedTag={selectedTagId}
            dataInicio={dataInicio}
            dataFim={dataFim}
            updateCount={(qtd, temMais, contagem) => setOpenCount(rotuloContagem(qtd, temMais, contagem))}
            style={applyPanelStyle("open")}
            selectedItems={selectedTickets}
            onSelectTicket={(value) => setSelectedTickets(value)}
            onMenuContexto={handleAbrirMenuContexto}
          />
          {/* Aba Grupos: escopo é só a conexão. Etapa, atendente e filial NÃO são
            enviados de propósito (grupo não tem lead) — o backend também ignora.
            O selectedTime aqui carrega o filtro de leitura (Nao lidos/Lidos). */}
          <TicketsList
            status="grupos"
            searchParam={searchParam}
            showAll={showAllTickets}
            selectedWhatsappIds={selectedWhatsappIds}
            selectedTime={selectedLeitura}
            selectedTag={selectedTagId}
            dataInicio={dataInicio}
            dataFim={dataFim}
            updateCount={(qtd, temMais) => setGroupCount(rotuloContagem(qtd, temMais))}
            style={applyPanelStyle("grupos")}
            selectedItems={selectedTickets}
            onSelectTicket={(value) => setSelectedTickets(value)}
            onMenuContexto={handleAbrirMenuContexto}
          />
          {user.renderAbaAguardando ? (
            <TicketsList
              status="pending"
              selectedQueueIds={selectedQueueIds}
              searchParam={searchParam}
              selectedWhatsappIds={selectedWhatsappIds}
              selectedTime={selectedTime}
              selectedTag={selectedTagId}
              dataInicio={dataInicio}
              dataFim={dataFim}
              updateCount={(qtd, temMais) => setPendingCount(rotuloContagem(qtd, temMais))}
              style={applyPanelStyle("pending")}
            />
          ) : (<></>)}
        </Paper>
      </TabPanel>
      <TabPanel value={tab} name="conexoes" className={classes.ticketsWrapper}>
        <TicketsWhatsappList
          whatsAppsIds={selectedWhatsappIds} />
      </TabPanel>
    </Paper >
  );
};

export default TicketsManager;
